import { RootState } from 'store';

const NDISSupportItemsLookupState = (state: RootState) => state.lookups.ndisSupportItems;

export const selectNDISSupportItems = (state: RootState) => NDISSupportItemsLookupState(state).row;
